import * as Colors from 'components/Material/Styles/Colors';
import { Styles } from 'material-ui';

const { Spacing } = Styles;

const styles = {
  textField: {
    fontSize: 20
    // color: Colors.Colors.fullWhite,
  },
  controls: {
    height: 38,
    margin: 0,
    padding: 0,
    borderRadius: 2,
    position: 'absolute',
    transition: 'all 0.3s ease',
    whiteSpace: 'nowrap'
  },
  addPageButtonContainer: {
    cursor: 'pointer',
    fontSize: '24px',
    lineHeight: '32px',
    height: 38,
    fontWeight: 300,
    paddingLeft: Spacing.desktopGutter,
    paddingRight: Spacing.desktopGutterMini,
    position: 'relative'
  },
  addPageButton: {
    boxShadow: 'none'
  },
  addSectionButton: {
    boxShadow: 'none'
  },
  addPageLabel: {
    textAlign: 'left'
  },
  addSectionButtonContainer: {
    cursor: 'pointer',
    fontSize: '24px',
    minHeight: '32px',
    height: 32,
    fontWeight: 300,
    paddingLeft: Spacing.desktopGutterMini,
    paddingRight: Spacing.desktopGutterMini,
    position: 'relative',
    marginTop: Spacing.desktopGutterMini
  },
  section: {
    position: 'relative',
    paddingTop: 16,
    paddingBottom: 16
  },
  page: {
    cursor: 'pointer',
    paddingLeft: 22,
    paddingRight: 18,
    borderStyle: 'none none none solid',
    borderWidth: Spacing.desktopGutterMini / 2,
    borderColor: 'transparent',
    position: 'relative',
    letterSpacing: '0.1px',
    lineHeight: '25.89px',
    paddingTop: 5,
    paddingBottom: 5
  },
  activePageHeader: {
    color: '#393939'
  },
  inactivePageHeader: {
    color: '#757575'
  },
  sectionHeader: {
    borderStyle: 'none none none solid',
    borderWidth: Spacing.desktopGutterMini / 2,
    borderColor: 'transparent',
    position: 'relative',
    fontSize: '20px',
    letterSpacing: '0.5px',
    lineHeight: '25.89px',
    paddingLeft: 22,
    paddingRight: 25,
    paddingTop: 5,
    paddingBottom: 5
  },
  activeSectionHeader: {
    color: '#393939'
  },
  inactiveSectionHeader: {
    color: '#757575'
  },
  taskCount: {
    lineHeight: '18px',
    minHeight: '18px',
    fontSize: '12px',
    paddingLeft: Spacing.desktopGutterMini,
    color: Colors.Colors.grey[400].material,
    position: 'absolute',
    bottom: '0'
  },
  input: {
    color: Colors.Colors.fullWhite
  },
  coverCaption: {
    position: 'absolute',
    left: 0,
    right: 0,
    bottom: 0,
    top: 0,
    height: 246
  },
  coverCourseName: {
    position: 'absolute',
    left: 26,
    right: 26,
    top: 36,
    color: Colors.Colors.fullWhite,
    fontSize: '25.89px',
    letterSpacing: '0.1px',
    lineHeight: '41.89px'
  },
  coverCourseBy: {
    textTransform: 'uppercase',
    color: Colors.Colors.fullWhite,
    position: 'absolute',
    left: 26,
    right: 26,
    bottom: 20,
    fontSize: 14
  },
  logoContainer: {
    height: 56,
    backgroundColor: Colors.Colors.fullBlack,
    opacity: 0.4,
    padding: Spacing.desktopGutterMini / 2,
    boxSizing: 'border-box'
  },
  logo: {
    margin: 'auto',
    display: 'block',
    boxSizing: 'border-box',
    height: 48,
    maxWidth: '100%',
    maxHeight: 48
  },
  answeredTask: {
    width: Spacing.desktopGutterMini * 2,
    height: Spacing.desktopGutterMini,
    borderRadius: Spacing.desktopGutterMini / 2,
    backgroundColor: Colors.Colors.fullWhite,
    display: 'inline-block',
    marginRight: Spacing.desktopGutterMini / 2
  },
  unansweredTask: {
    width: Spacing.desktopGutterMini * 2,
    height: Spacing.desktopGutterMini,
    borderRadius: Spacing.desktopGutterMini / 2,
    backgroundColor: 'rgba(255, 255, 255, 0.4)',
    display: 'inline-block',
    marginRight: Spacing.desktopGutterMini / 2
  },
  coursioLogoContainer: {
    textAlign: 'center',
    marginTop: Spacing.desktopGutterMore * 2
  }
};

export default styles;



// WEBPACK FOOTER //
// ./src/js/components/Course/TableOfContents/styles.js